
import React from 'react';

interface SummaryCardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  iconBgColor: string;
  iconColor: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ title, value, icon, iconBgColor, iconColor }) => {
  return (
    <div className="bg-white p-3 md:p-4 rounded-lg shadow-md flex items-center space-x-3 transition-all hover:shadow-lg">
      <div className={`p-2 md:p-3 rounded-full ${iconBgColor} ${iconColor}`}>
        {icon}
      </div>
      <div>
        <p className="text-xs text-slate-500">{title}</p>
        <p className="text-lg md:text-xl font-bold text-slate-800">{value}</p>
      </div>
    </div>
  );
};

export default SummaryCard;
